// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".fd5a5cc139d0714ff78090bfb566b2d3.js";
};